module.exports = "/assets/data/b2518a7940f84a82a51ad9afc46a01de-SE8.data.json";